export enum HttpMethod {
    get = 'get',
    GET = 'GET',
    delete = 'delete',
    DELETE = 'DELETE',
    head = 'head',
    HEAD = 'HEAD',
    options = 'options',
    OPTIONS = 'OPTIONS',
    post = 'post',
    POST = 'POST',
    put = 'put',
    PUT = 'PUT',
    patch = 'patch',
    PATCH = 'PATCH',
    link = 'link',
    LINK = 'LINK',
    unlink = 'unlink',
    UNLINK = 'UNLINK',
}

export enum HttpStatusCode {
    // eslint-disable-next-line no-magic-numbers
    SUCCESS = 200,
    // eslint-disable-next-line no-magic-numbers
    MULTIPLE_CHOICES = 300,
    // eslint-disable-next-line no-magic-numbers
    BAD_REQUEST = 400,
    // eslint-disable-next-line no-magic-numbers
    UNAUTHORIZED = 401,
    // eslint-disable-next-line no-magic-numbers
    FORBIDDEN = 403,
    // eslint-disable-next-line no-magic-numbers
    NOT_FOUND = 404,
    // eslint-disable-next-line no-magic-numbers
    CONFLICT = 409,
    // eslint-disable-next-line no-magic-numbers
    LOCKED = 423,
    // eslint-disable-next-line no-magic-numbers
    ERROR = 500,
}
